import { render, staticRenderFns } from "./radio-item.vue?vue&type=template&id=ce8c43e6&scoped=true"
import script from "./radio-item.vue?vue&type=script&lang=js"
export * from "./radio-item.vue?vue&type=script&lang=js"
import style0 from "./radio-item.vue?vue&type=style&index=0&id=ce8c43e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8c43e6",
  null
  
)

export default component.exports